<template>
  <b-card :title="title">
    <feather-icon
        icon="SettingsIcon"
        size="15"
        class="spinner"
        v-if="isLoading"
    />
    <app-echart-bar
        :option-data="option"
        v-if="!isLoading"
        @click="handleClick"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue';

import AppEchartBar from '@core/components/charts/echart/AppEchartBar';

export default {
  name: 'BarByState',
  components: {
    BCard,
    AppEchartBar
  },
  props: {
    title: {
      type: String
    },
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      option: {
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: { show: false }
          }
        ],
        grid: {
          left: '40px',
          right: '30px',
          bottom: '30px'
        },
        series: []
      }
    };
  },
  watch: {
    data() {
      this.loadIndicator();
    }
  },
  methods: {
    async loadIndicator() {
      const data = this.data.map((item) => ({
        ...item,
        name: item.name,
        value: item.quantity
      }));
      console.log('ASD', data);
      this.isLoading = true;
      const option = {};
      option.xAxisData = data.map((item) => item.name);
      option.series = [
        {
          name: 'Cantidad',
          type: 'bar',
          data
        }
      ];
      this.option.xAxis[0].data = option.xAxisData;
      this.option.series = option.series;

      this.isLoading = false;
    },
    handleClick({ data }) {
      console.log('handleClick', data);
    }
  },
  created() {
    this.loadIndicator();
  }
};
</script>
